module.exports = __webpack_public_path__ + "img/Marine.eb8a36c4.png";